import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import MuiAlert from "@material-ui/lab/Alert";
import { ListaDocumentacion } from '../Documentacion/ListaDocumentacion';
import { CertificadosPreAfiliado } from '../afiliaciones/CertificadosPreAfiliado';
import { TIPO_CERTIFICADOS } from '../../utils/constants';

const useStyles = makeStyles((theme) => ({
    rootListadoc: {
      margin: 30,
    },
  }));

export const  Case3 = (props) => {
    const {stateProvisorio } = useSelector((state) => state.stateProvisorio);
    const { cargada, items: certificados } = useSelector((state) => state.certificadosAfiliacion);
    const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);
    const certIncompleto = afiliadoEncontrado.incapacitado===1 && certificados.filter(s => s.tipoCertificado === TIPO_CERTIFICADOS.DISCAPACIDAD).length === 0;  
    const classes = useStyles();

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  return (
    <Grid item>
         <Grid className={classes.rootListadoc}>
                {!stateProvisorio ? (
                  <Alert severity="info">Estado documentación incorrecta</Alert>
                ) : (
                  <Alert severity="success">Estado documentación correcta</Alert>
                )}
                <Grid item className={classes.rootListadoc}>
                  <ListaDocumentacion
                    idListaDoc={"idListDocPreinscripto"}
                    idListValido={"idListValido"}
                    setHabilitado={props.setHabilitado}
                    fromBandeja={props.fromBandeja}
                  />
                </Grid>
                <Grid item >
                  <CertificadosPreAfiliado 
                    afiliado={afiliadoEncontrado}
                    certIncompleto={certIncompleto}
                    certificados={certificados}
                    cargada={cargada}
                  />
                </Grid>
        </Grid>
    </Grid>
  );
}